"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const constants_1 = require("../data/constants");
const intl_1 = require("../helpers/intl");
const store_1 = require("../context/store");
const actions_1 = require("../context/actions");
const fiatCurrencies_1 = __importDefault(require("../data/fiatCurrencies"));
const useGeoCurrency = (alpha2) => {
    const dispatch = (0, store_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        if (!alpha2)
            return;
        const country = (0, intl_1.getCountryByAlpha2)(alpha2);
        const isEnabled = fiatCurrencies_1.default.some((fiat) => fiat.abbr === (country === null || country === void 0 ? void 0 : country.currency));
        if (isEnabled) {
            dispatch({
                type: actions_1.CONTEXT_ACTIONS.SET_GEO_CURRENCY,
                payload: {
                    currency: country.currency,
                    currencyName: country.currencyName,
                },
            });
        }
        else {
            const fallbackCurrency = (0, intl_1.getCountryByAlpha2)(constants_1.FALLBACK_COUNTRY);
            dispatch({
                type: actions_1.CONTEXT_ACTIONS.SET_GEO_CURRENCY,
                payload: {
                    currency: fallbackCurrency.currency,
                    currencyName: fallbackCurrency.name,
                },
            });
        }
    }, [alpha2, dispatch]);
};
exports.default = useGeoCurrency;
//# sourceMappingURL=useGeoCurrency.js.map